import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f0dce48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "action-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_button = _resolveComponent("game-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_game_button, {
      alternative: _ctx.alternative,
      "is-large": _ctx.isLarge,
      "is-borderless": _ctx.isBorderless
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ]),
      _: 1
    }, 8, ["alternative", "is-large", "is-borderless"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flyOuts, (f) => {
      return (_openBlock(), _createElementBlock("div", {
        key: f.key,
        class: _normalizeClass(["action-button__flyout", _ctx.flyOutClass])
      }, _toDisplayString(f.value), 3))
    }), 128))
  ]))
}